import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {useSelector} from 'react-redux';
import ChatNotification from '../ChatNotification';
import ProMinusPopup from 'components/ProMinusPopup/index.js';
import {NewsLetterModal} from '../NewsLetterModal';

import DisclaimerModal from 'components/DisclaimerModal';
import SetPasswordModal from 'components/SetPassword';
import ChangePasswordModal from 'components/ChangePasswordModal';
import PasswordReminderModal from 'components/PasswordReminderModal';
import ResetPassword from 'components/ResetPassword';

function LoggedInRoute({component: Component, ...rest}) {
    const {auth} = useSelector(({global}) => global);
    return (
        <Route
            {...rest}
            render={(props) =>
                auth === null ? ( // user not authenticated yet so redirect to '/' => auth
                    <Redirect
                        to={{
                            pathname: '/',
                            state: {
                                from: props.location,
                                isProtected: true,
                            },
                        }}
                    />
                ) : auth ? ( // user is logged in so render component
                    <>
                        <Component {...props} />
                        {/* <ChatNotification {...props} /> */}
                        {/*<SetPasswordModal {...props} />*/}
                        <NewsLetterModal />
                        <DisclaimerModal {...props} />
                        <PasswordReminderModal {...props} />
                        <ChangePasswordModal {...props} />
                        <ProMinusPopup {...props} />
                        <ResetPassword />
                    </>
                ) : (
                    <Redirect // user is logged out so redirect to login
                        to={{
                            pathname: '/login',
                            state: {from: props.location},
                        }}
                    />
                )
            }
        />
    );
}

export default LoggedInRoute;
